import http from '@root/utils/axios/admin';

let state = {
    GiveawaysList: [],
    Giveaway: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchGiveawaysList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/giveaways', { params: filter }).then((response) => {
                commit('setGiveawaysList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    fetchGiveaway({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/giveaway', data).then((response) => {
                commit('setGiveaway', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },



}


let mutations = {
    setGiveawaysList(state, data) {
        state.GiveawaysList = data;
    },
    setGiveaway(state, data) {
        state.Giveaway.data = data;
    },
}

export default {
    state,
    actions,
    mutations
}